import {
  CRITICAL_STATUS,
  ERROR_STATUS,
  FAILURE_STATUS,
  INFO_STATUS,
  WARNING_STATUS,
} from "Common/constants/commonConstants";
import AppService from "Global/AppService";
import * as SystemConstants from "./SystemConstants";

export const addDeviceToSystemReducerState = (deviceId) => {
  return {
    type: SystemConstants.SYSTEM_COMPONENT_DEVICE_STATE_ADD,
    payload: deviceId,
  };
};

export const removeDeviceFromSystemReducerState = (deviceId) => {
  return {
    type: SystemConstants.SYSTEM_COMPONENT_DEVICE_STATE_REMOVE,
    payload: deviceId,
  };
};

export const fetchDeviceComponentList = (url, deviceId) => {
  return (dispatch) => {
    dispatch(fetchDeviceComponentListRequest(deviceId));

    function callback(success, err) {
      if (success && success.result) {
        const result = success.result.map((el) => {
          let statusCode = 4;
          if (
            el.status === CRITICAL_STATUS ||
            el.status === ERROR_STATUS ||
            el.status === FAILURE_STATUS
          ) {
            statusCode = 1;
          } else if (el.status === WARNING_STATUS) {
            statusCode = 2;
          } else if (el.status === INFO_STATUS) {
            statusCode = 3;
          } else {
            statusCode = 4;
          }
          return { ...el, statusCode };
        });
        dispatch(fetchDeviceComponentListSuccess(result, deviceId));
      } else {
        dispatch(fetchDeviceComponentListError(deviceId));
      }
    }

    AppService.getData(url, callback);
  };
};

const fetchDeviceComponentListRequest = (deviceId) => {
  return {
    type: SystemConstants.DEVICE_COMPONENT_LIST_FETCH_REQUEST,
    payload: deviceId,
  };
};

const fetchDeviceComponentListSuccess = (result, deviceId) => {
  return {
    type: SystemConstants.DEVICE_COMPONENT_LIST_FETCH_SUCCESS,
    payload: {
      result,
      deviceId,
    },
  };
};

const fetchDeviceComponentListError = (deviceId) => {
  return {
    type: SystemConstants.DEVICE_COMPONENT_LIST_FETCH_ERROR,
    payload: deviceId,
  };
};

export const changeSelectedFilterVals = (selectedFilterVals, deviceId) => {
  return {
    type: SystemConstants.CHANGE_SELECTED_FILTER_VALS,
    payload: {
      selectedFilterVals,
      deviceId,
    },
  };
};

export const changeSelectedComponent = (componentDetails, deviceId) => {
  return {
    type: SystemConstants.CHANGE_SELECTED_COMPONENT,
    payload: {
      selectedComponent: componentDetails,
      deviceId,
    },
  };
};

export const fetchComponentMetrics = (url, deviceId) => {
  return (dispatch) => {
    dispatch(fetchComponentMetricsRequest(deviceId));

    function callback(success, err) {
      if (success && success.result) {
        dispatch(fetchComponentMetricsSuccess(success.result, deviceId));
      } else {
        dispatch(fetchComponentMetricsError(deviceId));
      }
    }

    AppService.getData(url, callback);
  };
};

const fetchComponentMetricsRequest = (deviceId) => {
  return {
    type: SystemConstants.COMPONENT_METRICS_FETCH_REQUEST,
    payload: deviceId,
  };
};

const fetchComponentMetricsSuccess = (result, deviceId) => {
  return {
    type: SystemConstants.COMPONENT_METRICS_FETCH_SUCCESS,
    payload: {
      result,
      deviceId,
    },
  };
};

const fetchComponentMetricsError = (deviceId) => {
  return {
    type: SystemConstants.COMPONENT_METRICS_FETCH_ERROR,
    payload: deviceId,
  };
};

export const changeSelectedComponentMetric = (componentMetric, deviceId) => {
  return {
    type: SystemConstants.CHANGE_SELECTED_COMPONENT_METRIC,
    payload: {
      componentMetric,
      deviceId,
    },
  };
};

export const changeSelectedDateRange = (dateRange, deviceId) => {
  return {
    type: SystemConstants.CHANGE_SELECTED_DATE_RANGE,
    payload: {
      dateRange,
      deviceId,
    },
  };
};

export const fetchMeasurementVals = (url, deviceId) => {
  return (dispatch) => {
    dispatch(fetchMeasurementValsRequest(deviceId));

    function callback(success, err) {
      if (success && success.result) {
        dispatch(fetchMeasurementValsSuccess(success.result, deviceId));
      } else {
        dispatch(fetchMeasurementValsError(deviceId));
      }
    }

    AppService.getData(url, callback);
  };
};

const fetchMeasurementValsRequest = (deviceId) => {
  return {
    type: SystemConstants.COMPONENT_MEASUREMENT_VALS_FETCH_REQUEST,
    payload: deviceId,
  };
};

const fetchMeasurementValsSuccess = (result, deviceId) => {
  return {
    type: SystemConstants.COMPONENT_MEASUREMENT_VALS_FETCH_SUCCESS,
    payload: {
      result,
      deviceId,
    },
  };
};

const fetchMeasurementValsError = (deviceId) => {
  return {
    type: SystemConstants.COMPONENT_MEASUREMENT_VALS_FETCH_ERROR,
    payload: deviceId,
  };
};
